<rt-box
  [hasHoverState]="!disabled()"
  [hoverBackgroundColor]="backgroundHoverColor()"
  variant="padding-small"
  [class.disabled]="disabled()"
>
  @if (iconBackground) {
    <rt-icon-container
      [name]="icon()"
      [color]="iconColor()"
      [background]="isHovered() && !disabled() ? 'colorBgDefault' : iconBackground"
      containerSize="large-x"
      [size]="iconSize()"
      [class.icon-centered]="iconCentered()"
      margin-right-small-x
    />
  } @else {
    <rt-icon [name]="icon()" size="medium" margin-right [class.icon-centered]="iconCentered()" />
  }

  <div layout-vertical layout-flex-1-1>
    <div>
      <rt-heading>{{ heading() }}</rt-heading>
      @if (badgeText) {
        <rt-badge [color]="badgeVariant()" [text]="badgeText" margin-left-small-x />
      }
    </div>
    <rt-heading variant="subheading normal">{{ subheading() }}</rt-heading>
  </div>
  @if (!disabled() && hasArrowOnHover()) {
    <div>
      <rt-icon [name]="'chevron-right'" class="arrow-icon" />
    </div>
  }
</rt-box>
